import React from 'react';

const AdministrationUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M25.5 26h-19c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h13.09a1 1 0 01.71.3l5.91 6c.19.19.29.44.29.7v18c0 .55-.45 1-1 1zm-18-2h17V7.41L19.17 2H7.5v22z'
			></path>
			<path
				fill='#2d2d2d'
				d='M25.5 8h-6c-.55 0-1-.45-1-1V1h2v5h5v2zM22.5 16h-13v2h13v-2zM18.5 20h-9v2h9v-2zM25.5 30h-19v2h19v-2zM13 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM16.5 13h-2c0-.41-.53-1-1.5-1s-1.5.59-1.5 1h-2c0-1.65 1.57-3 3.5-3s3.5 1.35 3.5 3z'
			></path>
		</svg>
	);
};

export default AdministrationUnderline;
